import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import showicon from '../library/svg/show-icon.svg';
import hideicon from '../library/svg/hide-icon.svg';
import warning from "../library/svg/warning.svg";

const Login = () => {
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    isRevealed: false,
    errorMessage: {
      email: "",
      password: "",
    },
    stayedSignedin: false,
  });
  const [responseMessage, setResponseMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  // const [showPopup, setShowPopup] = useState(false);
  // const [popupTitle, setPopupTitle] = useState('');
  // const [popupMessage, setPopupMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setLoginForm((prevState) => ({
      ...prevState,
      [name]: value,
    }), () => {
      formValidator(name);
    });
  };

  const formValidator = (name) => {
    switch (name.toLowerCase()) {
      case "email":
        if (loginForm.email.match(/([a-zA-Z0-9._-])+@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,6})/)) {
          setLoginForm((prevState) => ({
            ...prevState,
            errorMessage: { ...prevState.errorMessage, email: "" },
          }));
        } else {
          setLoginForm((prevState) => ({
            ...prevState,
            errorMessage: { ...prevState.errorMessage, email: `Enter Valid E-mail` },
          }));
        }
        break;
      case "password":
        if (loginForm.password.match("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})")) {
          setLoginForm((prevState) => ({
            ...prevState,
            errorMessage: { ...prevState.errorMessage, password: "" },
          }));
        } else {
          setLoginForm((prevState) => ({
            ...prevState,
            errorMessage: { ...prevState.errorMessage, password: "Invalid Password Format" },
          }));
        }
        break;
      default:
        break;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const email = loginForm.email;
    const passwordcharacter = loginForm.password;
    let passwordArray = passwordcharacter.split("");
    let securedPassword = passwordArray.join("");

    const remember = loginForm.stayedSignedin;

    const data = JSON.stringify({
      email: email,
      password: securedPassword
    })

    var config = {
      method: "post",
      url: `${backendBookartUrl}/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        let JWTtoken = response.data.token;
        let emailId = response.data.useremailaddress;
        if (remember) {
          const current = new Date();
          const nextYear = new Date();
          nextYear.setFullYear(current.getFullYear() + 1);  /* Expired after 1 year*/
        }
        window.sessionStorage.setItem("JWTtoken", JWTtoken);
        window.sessionStorage.setItem("emailId", emailId);
        navigate("/home");
      })
      .catch((error) => {
        setErrorMessage(error.response.data.errormessage);
      });
  };


  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const email = loginForm.email;
  //   const passwordcharacter = loginForm.password;
  //   let passwordArray = passwordcharacter.split("");
  //   let securedPassword = passwordArray.join("");

  //   const remember = loginForm.stayedSignedin;

  //   const data = JSON.stringify({
  //     email: email,
  //     password: securedPassword
  //   })

  //   var config = {
  //     method: "post",
  //     url: `${backendBookartUrl}/login`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then((response) => {
  //       // Check the response and handle different cases
  //       if (response.data.case === "not authenticated") {
  //         
  //         const resetPasswordUrl = `${backendBookartUrl}/createPassword`;
  //         // Show the popup with the reset password link
  //         setErrorMessage('Wrong Password or Password Expired');
  //         handleShowPopup("Password Expired", (
  //           <div>
  //             <p>You have entered wrong password or</p>
  //               <p>Your Password is expired. <Link to="/createPassword" state={{ email: loginForm.email }}> Click here</Link> to reset your password.</p>
  //           </div>
  //       ));
  //       } else if (response.data.case === "authenticated") {
  //         if (response.data.emailid === "User does not exist !!") {
  //           setErrorMessage(response.data.emailid); // Handle user does not exist scenario
  //         } else {
  //           let JWTtoken = response.data.token;
  //           let emailId = response.data.useremailaddress;
  //           if (remember) {
  //             const current = new Date();
  //             const nextYear = new Date();
  //             nextYear.setFullYear(current.getFullYear() + 1);  // Expired after 1 year
  //           }
  //           window.sessionStorage.setItem("JWTtoken", JWTtoken);
  //           window.sessionStorage.setItem("emailId", emailId);
  //           navigate("/home");
  //         }
  //       } else {
  //         // Handle other cases, e.g., status code 404
  //         const statusCode = response.data.statuscode;
  //         if (statusCode === 404) {
  //           setErrorMessage(response.data.message); // User does not exist
  //         } else {
  //           setErrorMessage("An unexpected error occurred.");
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       // Handle network or other errors
  //       if (error.response) {
  //         // Server responded with a status other than 2xx
  //         setErrorMessage(error.response.data.errormessage || "An error occurred.");
  //       } else {
  //         // Network error or other unexpected errors
  //         setErrorMessage("Network error or unexpected error occurred.");
  //       }
  //     });
  // };



  const handleForgotLink = (event) => {
    event.preventDefault();

    // Check if the email is valid
    if (loginForm.email !== "" && loginForm.errorMessage.email === '') {
      // Update the error message state
      setLoginForm((prevState) => ({
        ...prevState,
        errorMessage: { ...prevState.errorMessage, email: "" },
      }));

      // Navigate to the forgot password page
      navigate("/forgotPassword", { state: { email: loginForm.email } });
    } else {
      // If the email is invalid, set the error message
      setLoginForm((prevState) => ({
        ...prevState,
        errorMessage: { ...prevState.errorMessage, email: "Enter valid E-mail" },
      }));
    }
  };



  const handleCheckBox = () => {
    setLoginForm((prevState) => ({
      ...prevState,
      stayedSignedin: !prevState.stayedSignedin,
    }));
  };

  const setReveal = () => {
    setLoginForm((prevState) => ({
      ...prevState,
      isRevealed: !prevState.isRevealed,
    }));
  };

  // const handleShowPopup = (title, message) => {
  //   setPopupTitle(title);
  //   setPopupMessage(message);
  //   setShowPopup(true);
  // };

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };

  useEffect(() => {
    if (location.state && location.state.message) {
      setResponseMessage(location.state.message);
    }
  }, [location.state]);

  return (
    <React.Fragment>
      <Header />
      <section className="body">
        <div className="container">
          <div className="card-content">
            <div className="es-card">
              <div className="es-card-body ">
                <img
                  alt="Elsevier"
                  className="elsevier-logo"
                  id="login"
                  src="ElsevierStyleSheet/images/elsevier-wordmark.svg"
                />
                <h3 className="es-card-title">Sign in</h3>
                <p className="es-card-text response">{responseMessage}</p>
                <p className="es-card-text">
                  Enter your email and password to continue with Bookart
                </p>
                <div className="formGroup">
                  {loginForm.errorMessage.email === "" ? (
                    <div className="es-input-text">
                      <input
                        id="email"
                        name="email"
                        value={loginForm.email}
                        placeholder="&nbsp;"
                        onChange={handleChange}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                  ) : (
                    <div className="es-input-text error">
                      <input
                        aria-invalid="true"
                        aria-describedby="email-error"
                        id="email"
                        name="email"
                        value={loginForm.email}
                        placeholder="&nbsp;"
                        onChange={handleChange}
                      />
                      <label htmlFor="email">Email</label>
                      <div
                        className="es-input-text-error text-start text-danger"
                        id="email-error"
                      >
                        <img src={warning} className="warning-img" alt="warning" />
                        {loginForm.errorMessage.email}
                      </div>
                    </div>
                  )}
                </div>
                <div className="formGroup">
                  {loginForm.errorMessage.password === "" ? (
                    <div className="es-input-text">
                      <input
                        id="password"
                        type={loginForm.isRevealed ? "text" : "password"}
                        name="password"
                        value={loginForm.password}
                        placeholder="&nbsp;"
                        onChange={handleChange}
                      />
                      <label htmlFor="password">Password</label>
                      {loginForm.password && (
                        <img
                          className="password-manage"
                          title={loginForm.isRevealed ? "hide password" : "show password"}
                          src={loginForm.isRevealed ? hideicon : showicon}
                          onClick={setReveal}
                          alt="toggle password visibility"
                        />
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="es-input-text error">
                        <input
                          aria-invalid="true"
                          aria-describedby="password-error"
                          id="password"
                          type={loginForm.isRevealed ? "text" : "password"}
                          name="password"
                          value={loginForm.password}
                          placeholder="&nbsp;"
                          onChange={handleChange}
                        />
                        <label htmlFor="password">Password</label>
                        {loginForm.password && (
                          <img
                            className="password-manage"
                            title={loginForm.isRevealed ? "hide password" : "show password"}
                            src={loginForm.isRevealed ? hideicon : showicon}
                            onClick={setReveal}
                            alt="toggle password visibility"
                          />
                        )}
                      </div>
                      <div className="es-input-text-error text-start text-danger">
                        <img src={warning} className="warning-img" alt="warning" />
                        {loginForm.errorMessage.password}
                      </div>
                    </>
                  )}
                </div>
                <div className="formGroup text-end font-16">
                  <button
                    className="es-link colored"
                    onClick={handleForgotLink}
                  >
                    Forgot your password?
                  </button>
                </div>
                <div className="formGroup text-start">
                  <label className="es-check small">
                    <input
                      className="es-check-input"
                      name="signedIn"
                      type="checkbox"
                      checked={loginForm.stayedSignedin}
                      onChange={handleCheckBox}
                    />
                    <span>Stay signed in </span>
                  </label>
                </div>
                <div className="formGroup">
                  <button
                    onClick={handleSubmit}
                    className="es-button primary w-100"
                    type="submit"
                    disabled={
                      loginForm.errorMessage.email !== '' ||
                      loginForm.errorMessage.password !== '' ||
                      loginForm.email === '' ||
                      loginForm.password === ''
                    }
                  >
                    <span>Continue</span>
                  </button>
                </div>
                {errorMessage !== '' ? (
                  <div className="formGroup">
                    <div className='error-message' dangerouslySetInnerHTML={{ __html: errorMessage }} />
                    {/* <div><Popup
                  title={popupTitle}
                  message={popupMessage}
                  show={showPopup}
                  handleClose={handleClosePopup}
                /></div> */}
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default Login;